import React, { useState, useEffect } from 'react';

const FormEditCategoria = ({ data, handleClose }) => {
    const [item, setItem] = useState({});

    useEffect(() => {
        if (data) {
            setItem({
                nombre: data.nombre || '',
                imagen: data.imagen || null
            });
        }
    }, [data]);

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        setItem((prevItem) => ({
            ...prevItem,
            [name]: type === 'file' ? files[0] : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        formData.append('nombre', item.nombre);
        if (item.imagen instanceof File) {
            formData.append('imagen', item.imagen);
        }

        fetch(`http://localhost:8080/api/categ/${data.id}`, {
            method: 'PUT',
            headers: {
                'authorization': sessionStorage.getItem('token')
            },
            body: formData,
        })
        .then((response) => {
            if (response.ok) {
                console.log('Elemento actualizado con éxito');
                handleClose();
            } else {
                console.error('Error al actualizar el elemento');
            }
        })
        .catch((error) => {
            console.error('Error de red:', error);
        });
    };

    return (
        <>
            <div className='container text-center'>
                <h3>Editar Categoría</h3>
            </div>
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <form onSubmit={handleSubmit}>
                            <div className="form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="floatingcategoriaFormEditcategoria"
                                    value={item.nombre}
                                    placeholder='Nombre'
                                    onChange={handleInputChange}
                                    name='nombre'
                                    required
                                />
                                <label htmlFor="floatingcategoriaFormEditcategoria"><h4>Nombre</h4></label>
                            </div>
                            <br />
                            <div className="form-floating">
                                <input
                                    type="file"
                                    className="form-control"
                                    id="floatingcategoriaFormEditImage"
                                    onChange={handleInputChange}
                                    name='imagen'
                                    accept="image/*"
                                />
                                <label htmlFor="floatingcategoriaFormEditImage"><h4>Imagen</h4></label>
                            </div>
                            <br />
                            <button type="submit" className="btn btn-primary">Editar</button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FormEditCategoria;
